__turbopack_context__.v({
  "flatDescription__booking": "FlatBookButton-module-scss-module__NfLk9G__flatDescription__booking",
  "flatDescription__disabledBooking": "FlatBookButton-module-scss-module__NfLk9G__flatDescription__disabledBooking",
  "flatDescription__switches": "FlatBookButton-module-scss-module__NfLk9G__flatDescription__switches",
});
